import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-brand-darkBlue" }
const _hoisted_2 = { class: "flex flex-row h-20 w-full top-0 z-20 xl:h-40 xl:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  id: "top",
  class: "h-full mx-auto xl:ml-4",
  src: "/assets/images/my-topia.png"
}, null, -1)
const _hoisted_4 = { class: "flex-row my-auto w-full gap-8 hidden justify-center xl:flex" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Share your city")
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "flex px-5 pb-5 top-0 z-30 relative justify-center xl:p-5 xl:absolute" }
const _hoisted_8 = {
  key: 0,
  class: "bg-brand-light-blue score-circle"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-3xl score-title" }, "Your score", -1)
const _hoisted_10 = { class: "font-black font-sans mb-2 score-text xl:mb-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "  text-xs text-white" }, [
  /*#__PURE__*/_createTextVNode(" Max Score: "),
  /*#__PURE__*/_createVNode("span", { class: "font-sans" }, "79"),
  /*#__PURE__*/_createTextVNode(", Min Score: "),
  /*#__PURE__*/_createVNode("span", { class: "font-sans" }, "-79 ")
], -1)
const _hoisted_12 = { class: "mt-3 text-base text-center w-2/3" }
const _hoisted_13 = {
  key: 1,
  class: "bg-brand-yellow2 score-circle"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "text-2xl score-title" }, "Mytopia score", -1)
const _hoisted_15 = { class: "font-black font-sans score-text" }
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "mt-3  text-xs text-white" }, [
  /*#__PURE__*/_createTextVNode(" Max Score: "),
  /*#__PURE__*/_createVNode("span", { class: "font-sans" }, "79"),
  /*#__PURE__*/_createTextVNode(", Min Score: "),
  /*#__PURE__*/_createVNode("span", { class: "font-sans" }, "-79 ")
], -1)
const _hoisted_17 = { class: "mt-3 text-base text-center w-2/3" }
const _hoisted_18 = { class: "border-white border-t-4 border-b-4 mb-5" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = {
  id: "city",
  class: "mx-auto cityCanvas xl:px-0",
  ref: "canvasRef"
}
const _hoisted_21 = { class: "w-full px-4 pb-4 bottom-0 xl:absolute" }
const _hoisted_22 = { class: "transition top-0 right-0 xl:w-1/4 xl:absolute xl:block" }
const _hoisted_23 = {
  key: 0,
  class: "bg-brand-darkBlue rounded-lg m-5 p-2"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "font-raleway font-extrabold m-2 text-white text-2xl" }, " Score breakdown: ", -1)
const _hoisted_25 = { class: "flex flex-col mb-4" }
const _hoisted_26 = {
  key: 1,
  class: "bg-brand-darkBlue rounded-lg font-raleway  m-5 text-white text-center text-xl leading-none p-4"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The community city encapsulates the "),
  /*#__PURE__*/_createVNode("span", { class: "font-semibold text-brand-yellow2" }, " most popular answers"),
  /*#__PURE__*/_createTextVNode(" chosen for each question in Mytopia. ")
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Each play of Mytopia contributes to the community city - demonstrating that "),
  /*#__PURE__*/_createVNode("span", { class: "font-semibold text-brand-pink" }, "all our actions and choices make a difference"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = { class: "font-sans font-bold text-brand-lightBlue mb-2 text-6xl" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", null, "contributions have been made to the community city so far!", -1)
const _hoisted_33 = {
  key: 0,
  class: "bg-brand-pink z-40 icon-scroll fixed scroller"
}
const _hoisted_34 = { class: "flex flex-col w-full px-5 items-center xl:hidden" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Share your city")
const _hoisted_36 = { class: "flex flex-col result-content xl:flex-row" }
const _hoisted_37 = { class: "mb-8 w-full result-image overflow-hidden result-content xl:w-2/5" }
const _hoisted_38 = { class: "w-full xl:ml-5 xl:w-3/5" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "flex mx-5 justify-center py-20 " }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#top",
    class: "nav-button"
  }, "Back to Top")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_share = _resolveComponent("share")
  const _component_scoreAvg = _resolveComponent("scoreAvg")
  const _component_catScore = _resolveComponent("catScore")
  const _component_resultBlock = _resolveComponent("resultBlock")
  const _component_infoGrid = _resolveComponent("infoGrid")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          class: "nav-button",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.swap())),
          disabled: !_ctx.canSwap
        }, _toDisplayString(_ctx.communityCityButton), 9, ["disabled"]),
        _createVNode(_component_share, { class: "nav-button" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode("button", {
          class: "nav-button",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.restartGame()))
        }, " Play again ")
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        (!_ctx.isCommunityCity)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("p", _hoisted_10, _toDisplayString(_ctx.getters.score), 1),
              _hoisted_11,
              _createVNode("p", _hoisted_12, _toDisplayString(_ctx.yourAverage), 1)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("p", _hoisted_15, _toDisplayString(_ctx.mytopiaAverage), 1),
              _hoisted_16,
              _createVNode("p", _hoisted_17, _toDisplayString(_ctx.cityAverage), 1)
            ]))
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (!_ctx.isLoaded)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    class: "bg-black h-full object-cover w-full absolute",
                    src: _ctx.state.screenshot
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode("canvas", _hoisted_20, null, 512)
        ])
      ]),
      _createVNode("div", _hoisted_21, [
        _createVNode(_component_scoreAvg, {
          playerScore: _ctx.getters.score,
          communityScore: _ctx.mytopiaAverage,
          max: _ctx.maxScore,
          min: _ctx.minScore,
          isCommunity: _ctx.isCommunityCity
        }, null, 8, ["playerScore", "communityScore", "max", "min", "isCommunity"])
      ]),
      _createVNode("div", _hoisted_22, [
        (!_ctx.isCommunityCity)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _hoisted_24,
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_catScore, {
                  score: _ctx.state.carbonFootprint,
                  title: "Carbon Footprint:",
                  min: _ctx.catMin,
                  max: _ctx.catMax
                }, null, 8, ["score", "min", "max"]),
                _createVNode(_component_catScore, {
                  score: _ctx.state.economicProsperity,
                  title: "Economic Prosperity:",
                  min: _ctx.catMin,
                  max: _ctx.catMax
                }, null, 8, ["score", "min", "max"]),
                _createVNode(_component_catScore, {
                  score: _ctx.state.employment,
                  title: "Employment:",
                  min: _ctx.catMin,
                  max: _ctx.catMax
                }, null, 8, ["score", "min", "max"]),
                _createVNode(_component_catScore, {
                  score: _ctx.state.healthHappinessAndWellbeing,
                  title: "Health, Happiness & Wellbeing:",
                  min: _ctx.catMin,
                  max: _ctx.catMax
                }, null, 8, ["score", "min", "max"]),
                _createVNode(_component_catScore, {
                  score: _ctx.state.wildlife,
                  title: "Wildlife:",
                  min: _ctx.catMin,
                  max: _ctx.catMax
                }, null, 8, ["score", "min", "max"])
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_26, [
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _createVNode("p", _hoisted_31, _toDisplayString(_ctx.computedPlays), 1),
              _hoisted_32
            ]))
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.scrolled)
          ? (_openBlock(), _createBlock("div", _hoisted_33))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_34, [
      _createVNode("button", {
        class: "nav-button",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.swap())),
        disabled: !_ctx.canSwap
      }, _toDisplayString(_ctx.communityCityButton), 9, ["disabled"]),
      _createVNode(_component_share, { class: "nav-button" }, {
        default: _withCtx(() => [
          _hoisted_35
        ]),
        _: 1
      }),
      _createVNode("button", {
        class: "nav-button",
        onClick: _cache[4] || (_cache[4] = $event => (_ctx.restartGame()))
      }, " Play again ")
    ]),
    (_ctx.resultAnswers.length > 0)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.resultAnswers, (a, index) => {
          return (_openBlock(), _createBlock("div", {
            key: a.text,
            class: "mx-5 xl:mx-20"
          }, [
            (_ctx.stats)
              ? _createVNode(_component_resultBlock, {
                  key: 0,
                  answer: _ctx.resultAnswers[index],
                  index: index,
                  isCommunity: _ctx.isCommunityCity
                }, null, 8, ["answer", "index", "isCommunity"])
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("img", {
                  src: `/assets/images/city/${a.key}.png`,
                  class: "h-full my-auto mx-auto object-contain w-full"
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode(_component_infoGrid, {
                  answers: _ctx.questions[index].answers,
                  selected: _ctx.resultAnswers[index]
                }, null, 8, ["answers", "selected"])
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("", true),
    _hoisted_39
  ]))
}